import { HostConfig, MountPoint } from 'docker-types';

import { useIsEdgeAdmin } from '@/react/hooks/useUser';
import { useCurrentEnvironment } from '@/react/hooks/useCurrentEnvironment';

import { usesRestrictedFeature } from './utils';
import { useMountedVolumes } from './useMountedVolumes';

/**
 * Hook to determine if the duplicate/edit button should be displayed
 */
export function useCanDuplicateEditContainer({
  autoRemove,
  partOfSwarmService,
  hostConfig,
  mounts,
  nodeName,
}: {
  autoRemove: boolean;
  partOfSwarmService: boolean;
  hostConfig?: HostConfig;
  mounts?: Array<MountPoint>;
  nodeName?: string;
}) {
  const environmentQuery = useCurrentEnvironment();
  const { isAdmin } = useIsEdgeAdmin();
  const environment = environmentQuery.data;

  const mountedVolumes = useMountedVolumes({
    environmentId: environment?.Id,
    nodeName,
    mounts,
    enabled:
      !isAdmin &&
      !!environment &&
      !environment.SecuritySettings.allowBindMountsForRegularUsers,
  });

  if (!environment || mountedVolumes.isLoading) {
    return false;
  }

  const restricted = usesRestrictedFeature(
    environment.SecuritySettings,
    hostConfig,
    mounts,
    mountedVolumes.volumes
  );

  return !partOfSwarmService && !autoRemove && (isAdmin || !restricted);
}
